// Light fuzzy-match against a list of candidate names — used to suggest alternatives
// when a typed ticker/index can't be verified. Scores exact → substring → token overlap.
export const fuzzyMatch = (q, candidates, topN = 3) => {
  const ql = String(q || "").toLowerCase();
  if (!ql || !Array.isArray(candidates) || !candidates.length) return [];
  const qTok = ql.split(/\s+/).filter((t) => t.length > 1);
  const scored = candidates.map((c) => {
    const cl = String(c).toLowerCase();
    let score = 0;
    if (cl === ql) score = 100;
    else if (cl.includes(ql) || ql.includes(cl)) score = 60;
    const cTok = cl.split(/\s+/);
    for (const qt of qTok)
      for (const ct of cTok) {
        if (ct === qt) score += 20;
        else if (ct.length > 2 && qt.length > 2 && (ct.includes(qt) || qt.includes(ct)))
          score += 10;
      }
    if (cl[0] === ql[0]) score += 2;
    return { c, score };
  });
  return scored
    .filter((x) => x.score > 0)
    .sort((a, b) => b.score - a.score)
    .slice(0, topN)
    .map((x) => x.c);
};
